import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Clipboard } from '../../core/clipboard/clipboard.model';

@Component({
    selector: 'app-clipboard-data-dialog',
    templateUrl: './clipboard-data-dialog.component.html',
    imports: [MatButtonModule, MatIconModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: [
        /* language=SCSS */
        `
            .location-change-dialog-panel {

                .mat-mdc-dialog-container {

                    .mat-mdc-dialog-surface {
                        padding: 0 !important;
                    }
                }
            }
        `
    ]
})
export class ClipboardDataDialogComponent {

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
           clipboardItem: Clipboard,
        },
        public dialogRef: MatDialogRef<ClipboardDataDialogComponent>,
    ) { }

    closeDialog() {
        this.dialogRef.close();
    }

}
